import { I18n } from '@calendly/i18n'
import { Avatar } from '@calendly/ui/components/avatar'
import { Button } from '@calendly/ui/components/button'
import { FullStoryExclude, FullStoryMask } from '@calendly/ui/components/fullstory-privacy'
import { BodyText, LabelText } from '@calendly/ui/components/typography'
import { useCallback } from 'react'
import { useHistory, useLocation } from 'react-router-dom'

import { useGetUserQuery } from 'common'
import { useProductRefreshAppShell } from 'features/app_shell'
import { camelize } from 'services/string_utils'
import { getEventLimitsSummary } from 'shared/utils'
import { getGlobalLimitsManageNavigationTarget } from 'shared/utils/global_limits_manage_navigation'

import {
  globalLimitsCardCss,
  globalLimitsUserCss,
  globalLimitsUserTextCss,
  sectionCss,
  sectionHeaderCss,
} from './styles'

export const GlobalLimitsCard = () => {
  const { data: currentUser } = useGetUserQuery()
  const history = useHistory()
  const location = useLocation()
  const isRebrandSettingsIaEnabled = useProductRefreshAppShell()

  const handleManageClick = useCallback(() => {
    history.push(getGlobalLimitsManageNavigationTarget({
      pathname: location.pathname,
      search: location.search,
      hash: location.hash,
      isRebrandSettingsIaEnabled,
    }))
  }, [
    history,
    isRebrandSettingsIaEnabled,
    location.hash,
    location.pathname,
    location.search,
  ])

  if (!currentUser) {
    return null
  }

  const eventLimits = camelize(currentUser.event_limits || currentUser.user_event_limits || {})
  const { dailyLimit, weeklyLimit, monthlyLimit } = eventLimits
  const isLimitSet = (limit) => limit !== undefined && limit !== null
  const summary = (
    !isLimitSet(dailyLimit) && !isLimitSet(weeklyLimit) && !isLimitSet(monthlyLimit)
  )
    ? I18n.t('publisher.event_type_editor_crud.scheduling_limits.no_global_limits')
    : getEventLimitsSummary(eventLimits)
  const displayName = I18n.t('publisher.event_type_editor_crud.scheduling_limits.current_user_name', {
    name: currentUser.name,
  })

  return (
    <section className={sectionCss} data-testid="global-limits-section">
      <div className={sectionHeaderCss}>
        <LabelText size="large">
          {I18n.t('publisher.event_type_editor_crud.scheduling_limits.global_limits')}
        </LabelText>
        <BodyText color="muted" size="medium">
          {I18n.t('publisher.event_type_editor_crud.scheduling_limits.global_limits_description')}
        </BodyText>
      </div>
      <div className={globalLimitsCardCss}>
        <div className={globalLimitsUserCss}>
          <FullStoryExclude>
            <Avatar
              alt={currentUser.name}
              letter={currentUser.avatar_letter}
              size="small"
              src={currentUser.avatar_url}
            />
          </FullStoryExclude>
          <div className={globalLimitsUserTextCss}>
            <LabelText size="large">
              <FullStoryMask>
                {displayName}
              </FullStoryMask>
            </LabelText>
            <BodyText color="muted" size="small">
              {summary}
            </BodyText>
          </div>
        </div>
        <Button
          decoration="secondary-outline"
          onClick={handleManageClick}
          size="small"
        >
          {I18n.t('publisher.event_type_editor_crud.scheduling_limits.manage')}
        </Button>
      </div>
    </section>
  )
}
